import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const loyaltyProducts = createSelector(membersState, (members) => members.loyaltyProducts);
